export default "__VITE_ASSET__c52e37f1__"